import { render, staticRenderFns } from "./appDropdownContent.vue?vue&type=template&id=08d6b874&"
import script from "./appDropdownContent.vue?vue&type=script&lang=js&"
export * from "./appDropdownContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports